import { Controller } from "stimulus";
import eventProxy from "../../assets/event-proxy";

export default class extends Controller {
    static targets = ["percent", "stroke", "gauge", "text", "event"];

    connect() {
        const update = () => this.updateCompleteness();
        this.$description = document.getElementById("426");
        this.$completeness_description = Array.from(document.querySelectorAll("[data-content=\"completeness-description\"]"));

        this.$data_fields = document.querySelectorAll("[data-for-completeness]");
        this.$data_fields.forEach(data_field => data_field.addEventListener("change", update));
        if (this.$description) {
            this.$description.addEventListener("keyup", update);
        }
        eventProxy.on("update-completeness-index", update);
        setTimeout(() => update(), 300);
    }

    getImagesScore() {
        let score = 0;
        const input = document.querySelector('[data-controller="fileuploader"]') || document.getElementById("fileuploader-input");
        const fileuploaderApi = input && jQuery && jQuery.fileuploader && jQuery.fileuploader.getInstance(input);
        if (fileuploaderApi) {
            fileuploaderApi.updateFileList();
            let imagesCount = fileuploaderApi.getFiles().length;
            for (var i = 0; i < Math.min(imagesCount, this.imageScores.length); i++) {
                score += this.imageScores[i];
            }
        }
        return score;
    }

    getAttributesScore() {
        let filled_count = 0;
        this.$data_fields.forEach(($data_field) => {
            if ($data_field.tagName === "SELECT") {
                filled_count += ($data_field.value > 0) ? 1 : 0;
            } else {
                filled_count += ($data_field.value) ? 1 : 0;
            }
        });
        let total_count = this.$data_fields.length;

        // Bei einigen Kategorien kann es sein, dass es keine dynamischen Attribute gibt. Dann voll Prozentzahl zurückgeben
        if (total_count == 0) return this.settings.percentForDynamicAttributes;

        let score = Math.round(this.settings.percentForDynamicAttributes * filled_count / total_count);
        return score;
    }

    getDescriptionScore() {
        if (!this.$description) {
            return 0;
        }
        var word_count = this.$description.value.split(/\s+/).length;
        var score = Math.min(word_count * this.settings.percentPerWordInDescription, this.settings.percentMaximumPerWordInDescription);
        return score;
    }

    updateCompleteness() {
        console.log('updating completeness... now');
        const score = this.getImagesScore() + this.getAttributesScore() + this.getDescriptionScore();
        const textkey = (score < this.settings.step2) ?
            'tpWeb.frontend.global.addMachineMachineData.label.completenessOfDescriptionNegativeInfo' :
            'tpWeb.frontend.global.addMachineMachineData.label.completenessOfDescriptionPositiveInfo';
        this.$completeness_description.forEach(el => el.textContent = translate(textkey, { value: score + "%" }));

        if (this.hasGaugeTarget) {
            this.gaugeTarget.dispatchEvent(new CustomEvent('gauge:set-value', {
                detail: {
                    value: score,
                    duration: 300
                }
            }));
        }
        // Kann weg wenn Maschine Bearbeiten umgebaut wurde
        if (this.hasPercentTarget) {
            this.percentTarget.setAttribute("data-percent", `${score}%`);
        }
        if (this.hasTextTarget) {
            this.textTarget.textContent = `${score}%`;
        }
        if (this.hasEventTarget) {
            this.eventTarget.dispatchEvent(new CustomEvent('completeness:update', {
                detail: {
                    score: score,
                    text: `${score}%`
                }
            }))
        }

        if (this.hasStrokeTarget) {
            this.strokeTarget.setAttribute("stroke-dashoffset", Math.round(score * 6.29));
        }
    }

    get settings() {
        if (this._setting === void 0) {
            this._settings = tpConfig("modules.offer.machinelist.completionIndex");
            for (var key in this._settings) {
                this._settings[key] = parseInt(this._settings[key]);
            }
        }
        return this._settings;
    }

    get imageScores() {
        if (this._imageScores === void 0) {
            this._imageScores = [
                this.settings.percentForFirstImage,
                this.settings.percentForSecondImage,
                this.settings.percentForFollowingImages
            ];
        }
        return this._imageScores;
    }
}